<template>
  <div class="m-10">
    <button v-if="!externalNavigation"
        @click="showHowTo = true"
        class="bg-indigo-600 hover:bg-indigo-700 text-white font-medium px-6 py-3 rounded-lg shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-150 border border-indigo-500 hover:border-indigo-400"
      >
        How-To Binaries
      </button>

    <HowToGuide
      v-if="isGuideVisible"
      :pages="binariesGuidePages"
      :initial-page="0"
      @close="handleClose"
      @complete="handleGuideComplete"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { ref, computed } from "vue";
import HowToGuide from "@/components/HowToGuide.vue";

import accountImage from "@/assets/howto/account/account.png";
import accountInformationImage from "@/assets/howto/account/account-information.png";
import accountStatusImage from "@/assets/howto/account/account-status.png";
import accountPermissions from "@/assets/howto/account/account-permissions.png";
import accountActions from "@/assets/howto/account/account-actions.png";
import accountPassword from "@/assets/howto/account/account-change-password.png";
import accountDelete from "@/assets/howto/account/account-delete.png";

import binariesImage from "@/assets/howto/binaries/binaries.png";
import binariesButtonImage from "@/assets/howto/binaries/binaries-button.png";
import binariesFormImage from "@/assets/howto/binaries/binaries-form.png";



export default {
  name: "ParentComponent",
  components: {
    HowToGuide,
  },
  
  props: {
    showHowToPage: {
      type: Boolean,
    },
    externalNavigation: {
      type: Boolean,
    }
  },

  emits: ["showHowToClose"],
  setup(props, { emit }) {
    const showHowTo = ref(false);

    const isGuideVisible = computed(() => {
      return props.externalNavigation ? props.showHowToPage : showHowTo.value;
    }); 

    const binariesGuidePages = ref([
    {
        heading: "Navigate to Binaries",
        upperText: [
            "From the main navigation menu, click on \"Workspace\".",
            "Select \"Binaries\" from the submenu.",
            "You'll see the Binaries Overview page showing all existing Binaries."
        ],
        image: binariesImage,
        imageAlt: "Binaries navigation screenshot",
        lowerText: []
    },
    {
        heading: "Initiate Binary Creation",
        upperText: [
            "Click the \"Add Binaries\" button.",
            "This will open the \"Add Binaries\" form.",
        ],
        image: binariesButtonImage,
        imageAlt: "Binary creation form",
        lowerText: []
    },
    {
        heading: "Initiate Binary Creation",
        upperText: [
           "Binary Overview Form" 
        ],
        image: binariesFormImage,
        imageAlt: "Binary creation form",
        lowerText: []
    },
    {
        heading: "Initiate Binary Creation",
        upperText: ["Required"],
        image: null,
        imageAlt: "Binary creation form",
        lowerText: [
            "Select the \"Binary Type\" from the drop down list.",
            "Select the \"Organisation\" from the drop down list.",
            "Click \"Choose File\" to upload the binary matching the selected \"Binary Type\".",
            "Click the \"Create Binary\" button to complete the creation." 
        ]
    },
    {
        heading: "Note",
        upperText: ["Optional"],
        image: null,
        imageAlt: "Binary creation form",
        notes: [
            "Select the \"Agent Group\" from the drop down list.",
            "Select the \"Agent\" from the drop down list.",
        ]
    },

]);

    const handleGuideComplete = () => {
      showHowTo.value = false;
      emit("showHowToClose", false);
    };

    const handlePageChange = (pageIndex) => {
      console.log(`User navigated to page ${pageIndex + 1}`);
    };

    const handleClose = () => {
      if (props.externalNavigation){
        emit("showHowToClose", false);
      } else {
        showHowTo.value = false;
      }
    }

    return {
      showHowTo,
      binariesGuidePages,
      handleGuideComplete,
      handlePageChange,
      handleClose,
      isGuideVisible
    };
  }
};
</script>